<template>
  <b-modal
    id="modal-filters-claim"
    centered
    title="Filtros"
    title-class="font-18"
    @shown="openModal"
  >
    <div class="row">
      <div class="col-12">
        <b-form-group label="ID Reclamação">
          <b-form-input v-model="localFilters.id" placeholder="Ex: 90" type="number" />
        </b-form-group>
      </div>
    </div>
        <div class="row">
      <div class="col-12">
        <b-form-group label="ID Reclame Aqui">
          <b-form-input v-model="localFilters.id_reclame_aqui" placeholder="Ex: 90" type="number" />
        </b-form-group>
      </div>
    </div>


    <div class="row">
      <div class="col-12">
        <b-form-group label="Selecione a data para filtrar">
          <date-range-picker
            id="range"
            ref="picker"
            v-model="date"
            class="w-100"
            :locale-data="localeDate"
            :show-week-numbers="false"
            :show-dropdowns="true"
            :auto-apply="false"
            :ranges="dateRanges"
          >
            <template
              v-if="date.startDate && date.endDate"
              v-slot:input="picker"
            >
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
            <template v-else v-slot:input> Selecione a data aqui</template>
          </date-range-picker>
        </b-form-group>
      </div>
    </div>

    <b-row>
      <b-col
        cols="12"
        md="12"
        sm="12"
        class="pb-3 input-padding container-pesquisa"
      >
        <b-form-select
          v-model="localFilters.event"
          placeholder="Tipo de evento"
          :options="[
            { value: null, text: 'Tipo de data' },
            { value: 'OPEN', text: 'Data de abertura' },
            { value: 'CLOSE', text: 'Data de encerramento' },
          ]"
          size="sm"
          @input="changedFilter"
        >
        </b-form-select>
      </b-col>

      <b-col
        cols="12"
        md="12"
        sm="12"
        class="pb-3 input-padding container-pesquisa"
      >
        <b-form-select
          v-model="localFilters.type"
          :options="[
            { value: null, text: 'Tipo da Reclamação' },
            { value: 'chargedback', text: 'Chargedback' },
            { value: 'refund', text: 'Reembolso' },
          ]"
          size="sm"
          @input="changedFilter"
        >
        </b-form-select>
      </b-col>

      <b-col
        cols="12"
        md="12"
        sm="12"
        class="pb-3 input-padding container-pesquisa"
      >
        <b-form-group label="Status">
          <b-form-select
            v-model="localFilters.status"
            aria-placeholder="Status"
            multiple
            :disabled="isProgressFilterActive"
            :options="[
              { value: 'not_closed', text: 'Todas as reclamações (menos encerradas)' },
              { value: 'close', text: 'Encerrada' },
              { value: 'close_solicitation', text: 'Solicitação de encerramento' },
              { value: 'refund_pending', text: 'Solicitação de reembolso' },
              { value: 'refunded', text: 'Reembolsado' },
              { value: 'refunded_automatically', text: 'Reembolso automático' },
              { value: 'refund_denied', text: 'Reembolso negado' },
              {
                value: 'waiting_answer_seller',
                text: 'Aguardando resposta do Vendedor',
              },
              {
                value: 'waiting_answer_client',
                text: 'Aguardando resposta do Cliente',
              },
            ]"
            size="sm"
            @input="changedFilter"
          >
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="12"
        sm="12"
        class="pb-3 input-padding container-pesquisa"
      >
        <b-form-group label="Progresso">
          <b-form-select
            v-model="localFilters.progress_status"
            aria-placeholder="Status do progresso"
            multiple
            :disabled="isStatusFilterActive"
            :options="[
              { value: 'AWAITING_3DU', text: 'Aguardando 3DU' },
              { value: 'OUT_OF_WARRANTY', text: 'Fora do prazo de garantia' },
              { value: 'IN_PROGRESS', text: 'Em tratativa' },
              { value: 'AUTO_CLOSED', text: 'Encerrada automaticamente' },
              { value: 'CLOSED', text: 'Encerrada' },
            ]"
            size="sm"
            @input="changedFilter"
          >
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="12"
        sm="12"
        class="pb-3 input-padding container-pesquisa"
      >
        <b-form-group label="Prazo">
          <b-form-select
            v-model="localFilters.overdue"
            :options="[
              { value: null, text: 'Todas' },
              { value: 'true', text: 'Somente vencidas' },
              { value: 'false', text: 'Somente não vencidas' },
            ]"
            size="sm"
            @input="changedFilter"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" @click="cancel">Cancelar</b-button>
      <b-button variant="success" @click="clearFilter">Limpar Filtros</b-button>
      <b-button variant="success" @click="onSubmit">Ok</b-button>
    </template>
  </b-modal>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'

export default {
  components: {
    DateRangePicker,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({
        type: null,
        event: null,
        id: null,
        id_reclame_aqui: null,
        status: ['not_closed'],
        progress_status: [],
        overdue: null,
        date_start: moment().utcOffset(-180).startOf('month').format('YYYY-MM-DDTHH:mm:ssZ'),
        date_end: moment().utcOffset(-180).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
      })
    }
  },
  data() {
    return {
      date: {
        startDate: null,
        endDate: null,
      },
      localeDate: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
      localFilters: {
        type: null,
        event: null,
        id: null,
        id_reclame_aqui: null,
        status: ['not_closed'],
        progress_status: [],
        overdue: null,
      },
    }
  },
  computed: {
    isStatusFilterActive() {
      return this.isStatusSelectionMeaningful(this.localFilters.status)
    },
    isProgressFilterActive() {
      return !!this.localFilters.progress_status && this.localFilters.progress_status.length > 0
    },
    dateRanges() {
      let today = moment().startOf('day').toDate()

      let yesterday = moment().subtract(1, 'days').startOf('day').toDate()

      let lastWeek = moment().subtract(7, 'days').startOf('day').toDate()

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          moment().startOf('month').toDate(),
          moment().endOf('month').toDate(),
        ],
        'Este ano': [
          moment().startOf('year').toDate(),
          moment().endOf('year').toDate(),
        ],
        'Último mês': [
          moment().subtract(1, 'months').startOf('month').toDate(),
          moment().subtract(1, 'months').endOf('month').toDate(),
        ],
      }
    },
  },

  watch: {
    'localFilters.status'(newStatus) {
      if (this.isStatusSelectionMeaningful(newStatus) && this.localFilters.progress_status.length) {
        this.localFilters.progress_status = []
      }
    },
    'localFilters.progress_status'(newProgressStatus) {
      if (newProgressStatus.length && this.isStatusSelectionMeaningful(this.localFilters.status)) {
        this.localFilters.status = ['not_closed']
      }
    },
  },

  methods: {
    isStatusSelectionMeaningful(status) {
      return !!status && status.length > 0 && !(status.length === 1 && status[0] === 'not_closed')
    },

    openModal() {
      // Carrega os filtros das props para o estado local
      this.localFilters = {
        type: this.filters.type,
        event: this.filters.event,
        id: this.filters.id,
        id_reclame_aqui: this.filters.id_reclame_aqui,
        status: this.filters.status ? [...this.filters.status] : ['not_closed'],
        progress_status: this.filters.progress_status ? [...this.filters.progress_status] : [],
        overdue: this.filters.overdue !== undefined ? this.filters.overdue : null,
      }

      // Carrega as datas se existirem
      if (this.filters.date_start && this.filters.date_end) {
        this.date.startDate = moment(this.filters.date_start)
        this.date.endDate = moment(this.filters.date_end)
      } else {
        this.date = {
          startDate: null,
          endDate: null,
        }
      }
    },

    changedFilter() {},

    clearFilter() {
      localStorage.removeItem('filter_claim')
      localStorage.removeItem('search_claim')
      localStorage.removeItem('page_claim')
      this.$emit('close', {
        type: null,
        event: null,
        id: null,
        id_reclame_aqui: null,
        status: ['not_closed'],
        progress_status: [],
        overdue: null,
        date_start: moment().utcOffset(-180).startOf('month').format('YYYY-MM-DDTHH:mm:ssZ'),
        date_end: moment().utcOffset(-180).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
      })
      this.$bvModal.hide('modal-filters-claim')
    },

    onSubmit() {
      let data = { ...this.localFilters }

      if (this.date.startDate) {
        data.date_start = moment(this.date.startDate)
          .utcOffset(-180)
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm:ssZ')
      }

      if (this.date.endDate) {
        data.date_end = moment(this.date.endDate)
          .utcOffset(-180)
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm:ssZ')
      }

      this.$emit('close', data)
      this.$bvModal.hide('modal-filters-claim')
    },
  },
}
</script>
<style scoped>
#range {
  width: 100%;
  height: 45px;
}
</style>
